import { render, staticRenderFns } from "./orderTag.vue?vue&type=template&id=5953ade4&scoped=true&"
import script from "./orderTag.vue?vue&type=script&lang=js&"
export * from "./orderTag.vue?vue&type=script&lang=js&"
import style0 from "./orderTag.vue?vue&type=style&index=0&id=5953ade4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953ade4",
  null
  
)

export default component.exports